module.exports = __webpack_public_path__ + "static/ISOCPEUR.86e5ce86.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/ISOCPEUR.ttf
// module id = 304
// module chunks = 114276838955818